import { EXPERTISE_AREAS } from "../data/ResumeData";
import SectionHeader from "./SectionHeader";

function Expertise() {
  return (
    <section aria-labelledby="expertise-heading">
      <SectionHeader title="Areas of Expertise" />
      <h2 id="expertise-heading" className="sr-only">Areas of Expertise</h2>

      <ul className="flex flex-wrap gap-1.5">
        {EXPERTISE_AREAS.map((area) => (
          <li
            key={area}
            className="inline-flex items-center rounded-md bg-accent-cool/20 border border-accent-cool/60 px-2.5 py-1 text-[12.5px] text-fg hover:bg-accent-cool/35 hover:border-accent-cool transition-colors"
          >
            {area}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default Expertise;
